import {FC, useCallback, useEffect, useMemo, useState} from 'react';

import {useLocation, useNavigate} from 'react-router-dom';

import {SetPassword} from '../../components/modals/SetPassword';

import {useRecoilValue} from 'recoil';
import {authState} from '../../store/auth/atoms';
import {Dashboard} from '../../components/Dashboard';
import {Stack} from '@mui/material';
import {getIsUserCustomer, getIsUserWorker} from '../../global/lib';

const Main: FC = () => {
  const {user} = useRecoilValue(authState);
  const [open, setOpen] = useState(false);
  const nav = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (nav.search.indexOf('?pass') >= 0 && user?.needToChangePasswd) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nav.search]);

  const isWorker = useMemo(() => {
    return getIsUserWorker(user);
  }, [user]);
  const isCustomer = useMemo(() => {
    return getIsUserCustomer(user);
  }, [user]);
  const shouldStayForPasswordModal = Boolean(user?.needToChangePasswd && nav.search.indexOf('?pass') >= 0);
  const shouldRedirectToServiceRequests = (isWorker || isCustomer) && !shouldStayForPasswordModal;

  const handleClose = useCallback(() => {
    setOpen(false);
    navigate(isWorker || isCustomer ? '/serviceRequests' : '/', {replace: true});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCustomer, isWorker]);

  useEffect(() => {
    if (shouldRedirectToServiceRequests) {
      navigate('/serviceRequests', {replace: true});
    }
  }, [navigate, shouldRedirectToServiceRequests]);

  return (
    <>
      {!shouldRedirectToServiceRequests && (
        <Stack direction="row" sx={{padding: '0 20px'}}>
          <Dashboard />
        </Stack>
      )}
      {/* <div className={styles.main}>
                <div className={styles.navCards}>
                    <NavCards menu={[...firstMenu.slice(1), secondMenu[1]]}/>
                </div>
            </div> */}
      <SetPassword open={open} handleClose={handleClose} />
    </>
  );
};

export default Main;
